import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {IAccount} from '../accounts/account';
import {IResponse} from '../../batches/batches.service';
import {MIHttpClientService} from 'src/app/shared/mi-http-client.service';
import {IdName} from 'src/app/shared/common-interfaces';
import {map} from 'rxjs/operators';
import {IClient, toClient} from "../../batches/clients/client";


@Injectable({
  providedIn: 'root',
})
export class BusinessOrgProfileService {

  constructor(private miClient: MIHttpClientService) { }

  getBusinessOrgProfileById(id: number): Observable<IAccount> {
    return this.miClient.get<IAccount>('accounts/' + id);
  }

  deleteBrand(id: number): Observable<any> {
    return this.miClient.delete('accounts/' + id + '/brand');
  }

  deleteRetailer(id: number): Observable<any> {
    return this.miClient.delete('accounts/' + id + '/retailer');
  }

  deleteClient(id: number): Observable<any> {
    return this.miClient.delete('accounts/' + id + '/client');
  }

  createBusinessOrgProfile(item: IAccount): Observable<any> {
    delete item.id;
    return this.miClient.post('accounts', item);
  }

  updateBusinessOrgProfile(item: any): Observable<any> {
    return this.miClient.post('accounts/' + item.id, item);
  }

  filterAccountsByName(name: string): Observable<IResponse> {
    if (name === null || typeof name !== 'string') {
      return of({ list: [], TotalRowCount: 0 });
    }
    return this.miClient.get<IResponse>('accounts?accountName=' + encodeURIComponent(name));
  }

  displayAccountName(account: any) {
    if (account) {
      return account.accountName;
    }
  }

  getRetailersAsIdNames(): Observable<IdName[]> {
    return this.getRetailers()
    .pipe(
      map( results => results.map( state => {
        return {
          id: state.id,
          name: state.accountName,
        };
      })),
    );
  }

  getRetailers(): Observable<IAccount[]> {
    return this.miClient.get<IResponse>('accounts?isRetailer=true')
      .pipe(
        map(({ list }) => list),
      );
  }

  getBrands(): Observable<IAccount[]> {
    return this.miClient.get<IResponse>('accounts?isBrand=true').pipe(map(({ list }) => list));
  }

  getClients(): Observable<IClient[]> {
    return this.miClient.get<IResponse>('accounts?isClient=true').pipe(
      map(({list}) => list),
      map((list) => list.map(account => toClient(account)))
    );
  }

}
